import dismissed from '../utils/dismissed';

export default function(oneSignal, options){
    if (oneSignal.isPushNotificationsSupported()) {
        return oneSignal.isPushNotificationsEnabled().then(function(enabled){
            if (!enabled) {
                if (!dismissed((options || {}).dismiss)) {
                    return oneSignal;
                } else {
//                    throw 'dismission';
                    return Promise.reject('dismission');
                }
            } else {
//                throw 'already subscribed';
                return Promise.reject('already subscribed');
            }
        });
    } else {
        return Promise.reject('unsupported');
    }
}




//////////////////
// WEBPACK FOOTER
// ./src/utils/should-subscribe.js
// module id = 15
// module chunks = 0